import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { getLocaleDate } from '../../shared/utils/appUtils';
export const ReviewIsvReply = (props)=>{
    const classNames = require('classnames-minimal');
    const [isImageLoadingError, setIsImageLoadingError] = React.useState(false);
    const imageClassName = classNames({
        isvIcon: !isImageLoadingError
    });
    const containerClasses = classNames({
        isvReplyContainer: true,
        [props.classes]: props.classes
    });
    const replyDate = getLocaleDate(props.isvReply.replied_at, props.locale);
    const handleLoadError = ()=>{
        setIsImageLoadingError(true);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: containerClasses,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "isvReplyTitle",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        className: imageClassName,
                        alt: "product-icon",
                        src: props.iconUrl,
                        onError: handleLoadError
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "isvName",
                        children: props.publisherName ? props.publisherName : ''
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "replyDate",
                        children: [
                            "replied on ",
                            replyDate
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "isvReplyContent",
                children: props.isvReply.content
            })
        ]
    });
};
